export enum MsftQualificationEnum {
  DIRECT = 'Direct',
  MARKETING_QUALIFIED = 'MarketingQualified',
  SALES_QUALIFIED = 'SalesQualified',
}
